define('common/views/chatbot_view',['require','exports','module','lodash','jquery','backbone','i18n','services/auth','common/models/appstate'],function (require, exports, module) {
  'use strict';

  var _ = require('lodash'),
    $ = require('jquery'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    AppState = require('common/models/appstate');

  var ChatbotView = Backbone.View.extend({
    CHATBASE_ID: 'WR-GMrZMiBjziaIfCDbyA',
    userLang: i18n.lng(),

    initialize: function (options) {
      this.options = options;
      this.userLang = i18n.lng();
      if (AppState._companyInfo) {
        this.listenTo(AppState._companyInfo, 'all', this.render);
      }
    },

    render: function () {
      var token = AppState.getChatbaseToken();

      if (token) {
        if (!window.chatbase || window.chatbase('getState') !== 'initialized') {
          window.chatbase = (...args) => {
            if (!window.chatbase.q) {
              window.chatbase.q = [];
            }
            window.chatbase.q.push(args);
          };
          window.chatbase = new Proxy(window.chatbase, {
            get(target, prop) {
              if (prop === 'q') {
                return target.q;
              }
              return (...args) => target(prop, ...args);
            },
          });
        }
        window.chatbase('resetUser');
        setTimeout(() => {
          const user_metadata = {
            language: this.userLang,
            cf_gru_id: authInfo.getGroupId(),
            email_r: AppState.getEmail(),
            empId: authInfo.getCompanyId(),
            name_r: AppState.getFirstName() + ' ' + AppState.getLastname(),
            roleId: AppState.getRolId(),
            cf_plan: AppState.getPlan(),
            cf_grupo_region: AppState.getCountryId(),
            accountId: AppState.getGroupName(),
          };
          const uid = authInfo.getUserId();
          const rootEmail = uid.includes('@') ? uid : `${uid}@old.interno`;
          window.chatbase('identify', {
            token: token,
            user_id: authInfo.getUserId(),
            email: rootEmail,
            name: authInfo.getUserId(),
            user_metadata: JSON.stringify(user_metadata),
          });
        }, 500);

        window.chatbase.setInitialMessages([$.i18n.translate('chatbase.hello')]);
        if (!document.getElementById(this.CHATBASE_ID)) {
          const script = document.createElement('script');
          script.src = 'https://www.chatbase.co/embed.min.js';
          script.id = this.CHATBASE_ID;
          script.setAttribute('chatbotId', this.CHATBASE_ID);
          script.setAttribute('domain', 'www.chatbase.co');
          script.defer = true;

          script.onload = () => {
            console.info('Chatbase BOT loaded and identified.');
          };
          document.body.appendChild(script);
        }
      } else {
        console.warn('No se encontró chatbase_token');
      }
      return this;
    },
  });

  module.exports = ChatbotView;
});

